import { render, staticRenderFns } from "./BeneficiaryEdit.vue?vue&type=template&id=9982c204&scoped=true&"
import script from "./BeneficiaryEdit.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9982c204",
  null
  
)

export default component.exports